module.exports = __webpack_public_path__ + "static/img/good2.fca423a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/index/good2.jpg
// module id = F8bn
// module chunks = 30